import BaseObject from "./BaseObject";
import NP from "./NP";
import './Fonts/Open Sans.css';

export interface IFont {
	Modifier?: string,
	FontFamily?: string,
	Size?: number,
	Color?: string,
	IsBold?: boolean,
	IsItalic?: boolean,
	IsUnderline?: boolean
}

export default class Font extends BaseObject {
	private _FontFamily: string;
	private _Size: any;
	private _Color: string;
	private _UseAutoColor: boolean;
	private _IsBold: boolean;
	private _IsItalic: boolean;
	private _IsStriken: boolean;
	private _IsUnderline: boolean;
	private _IsSuperior: boolean;
	private _Modifier: string;
	private _LineHeight: number;
	private _IsInferior: boolean;
	private _IsLowerCapitalized: boolean;
	private _IsCapitalized: boolean;

	constructor(settings: object)
	{
		super(settings);
		if (this._Modifier)
			this.setModifier(this._Modifier);
	}

	_initFields(settings: object)
	{
		this._Size = 14;
		this._Color = 'rgba(0,0,0,0.87)';
		this._UseAutoColor = false;
		this._IsBold = false;
		this._IsItalic = false;
		this._IsStriken = false;
		this._IsUnderline = false;
		this._IsSuperior = false;
		this._Modifier = '';
		this._LineHeight = 1;
		this._IsInferior = false;
		this._IsLowerCapitalized = false;
		this._IsCapitalized = false;
		this._FontFamily = NP.FontFamily;
		super._initFields(settings);

		if (this._Size)
			this._Size = parseFloat(this._Size);
	}

	getFontFamily()
	{
		if (this._FontFamily == "Default")
			return NP.FontFamily;
		else
			return this._FontFamily;
	}

	setFontFamily(value: string)
	{
		if (!value)
			return;
		this._FontFamily = value;
	}

	getSize()
	{
		return this._Size;
	}

	setSize(value: number)
	{
		if (!value)
			return;
		this._Size = value;
	}

	getColor()
	{
		return this._Color;
	}

	setColor(value: string)
	{
		this._Color = value;
	}

	getUseAutoColor()
	{
		return this._UseAutoColor;
	}


	getIsBold()
	{
		return this._IsBold;
	}

	setIsBold(value: boolean)
	{
		this._IsBold = value;
		this._Modifier = value ? "Bold" : "" + this._IsItalic ? (value ? " " : "") + "Italic" : "";
	}

	getIsItalic()
	{
		return this._IsItalic;
	}

	setIsItalic(value: boolean)
	{
		this._IsItalic = value;
		this._Modifier = (this._Modifier || "").replace("Italic", "");
		this._Modifier = this._Modifier.trim();
		if (value)
			this._Modifier += (this._Modifier.length ? " " : "") + "Italic";
	}


	getIsUnderline()
	{
		return this._IsUnderline;
	}

	setIsUnderline(value: boolean)
	{
		this._IsUnderline = value;
	}


	setModifier(value: string)
	{
		value = value || "";
		let allMods = NP.Font.Modifier[this._FontFamily] || NP.Font.Modifier[NP.FontFamily];
		if (!allMods)
			return;

		let italicIndex = value.indexOf("Italic");
		this._Modifier = value;
		this._IsItalic = italicIndex > -1;
		if (italicIndex === -1)
			this._IsBold = (value === "Bold");
		else
			this._IsBold = value.substr(0, italicIndex).trim() === "Bold";
	}

	getLineHeight()
	{
		return this._LineHeight;
	}

	getFontWeight()
	{
		let str = (this._Modifier || "").replace("Italic", "").trim();
		return NP.Font.Weight[str] || 400;
	}

	toCSS()
	{
		let res = "color:" + this.getColor() + ";";
		res += "font-size:" + this.getSize() + "px;";
		res += "font-family:" + this.getFontFamily() + ";";
		res += "font-weight:" + this.getFontWeight() + ";";
		res += "font-style:" + (this.getIsItalic() ? 'italic;' : 'normal;');
		res += "text-decoration:" + (this.getIsUnderline() ? 'underline;' : 'none;');
		return res;
	}

	toJsonCSS()
	{
		let res = <any>{
			color: this.getColor(),
			fontFamily: this.getFontFamily(),
			fontWeight: this.getFontWeight(),
			fontStyle: (this.getIsItalic() ? 'italic' : 'normal'),
			textDecoration: this.getIsUnderline() ? 'underline' : 'none'
		};

		if (this._Size)
			res.fontSize = this._Size + 'px';

		return res;
	}

	applyToNode(node: HTMLElement)
	{
		node.style.color = this.getColor();
		node.style.fontSize = this.getSize() + 'px';
		node.style.fontFamily = this.getFontFamily();
		node.style.fontWeight = this.getFontWeight();
		node.style.fontStyle = this.getIsItalic() ? 'italic' : 'normal';
		node.style.textDecoration = this.getIsUnderline() ? 'underline' : 'none';
	}

	getSettings()
	{
		return {
			FontFamily: this._FontFamily,
			Size: this._Size,
			Color: this._Color,
			UseAutoColor: this._UseAutoColor,
			IsBold: this._IsBold,
			IsItalic: this._IsItalic,
			IsStriken: this._IsStriken,
			IsUnderline: this._IsUnderline,
			IsSuperior: this._IsSuperior,
			Modifier: this._Modifier
		};
	}

	static getAllFontsRules()
	{
		let style = document.querySelector('link[href*="style.css"]') as HTMLLinkElement;
		return new Promise(resolve =>
		{
			fetch(style.href, {
				method: "GET"
			})
				 .then((response: any) => response.text())
				 .then((response: string) =>
				 {
					 let r = /@font-face\s*{([\s\S]*?)}/mg,
						  match,
						  res = "";

					 while (match = r.exec(response))
						 res += match[0] + '\n';

					 resolve(res);
				 });
		});
	}

};

NP.Font = Font;

NP.Font.Modifier = {
	"Arial": ["Bold", "Italic", "Bold Italic"],
	"Times New Roman": ["Bold", "Italic", "Bold Italic"],
	//"Lato": ["Thin", "Light", "Bold", "Black", "Thin Italic", "Light Italic", "Bold Italic", "Black Italic"],
	"Montserrat": ["Thin", "Light", "Medium", "Bold", "Black", "Thin Italic", "Light Italic", "Medium Italic", "Bold Italic", "Black Italic"],
	"Noto Sans": ["Bold", "Italic", "Bold Italic"],
	"Open Sans": ["Light", "Semibold", "Bold", "Extrabold", "Italic", "Light Italic", "Semibold Italic", "Bold Italic", "Extrabold Italic"],
	"Playfair Display": ["Italic", "Bold", "Bold Italic", "Black", "Black Italic"],
	"PT Sans": ["Bold", "Italic", "Bold Italic"],
	"PT Sans Narrow": ["Bold"],
	"PT Serif": ["Bold", "Italic", "Bold Italic"],
	"Roboto": ["Thin", "Light", "Medium", "Bold", "Black", "Italic", "Thin Italic", "Light Italic", "Medium Italic", "Bold Italic", "Black Italic"],
	"Roboto Condensed": ["Light", "Bold", "Italic", "Light Italic", "Bold Italic"],
	"Roboto Mono": ["Thin", "Light", "Bold", "Medium", "Thin Italic", "Light Italic", "Medium Italic", "Bold Italic"],
	"Source Sans Pro": ["Extra Light", "Light", "Medium", "Semibold", "Bold", "Black", "Italic", "Extra Light Italic", "Light Italic", "Semibold Italic", "Bold Italic", "Black Italic"],
	"Ubuntu": ["Light", "Medium", "Bold", "Italic", "Light Italic", "Medium Italic", "Bold Italic"]
};

NP.Font.defaultLineHeights = {
	'Bad Script': 1.75,
	'Lobster': 1.5
};

NP.Font.Weight = {
	"Thin": 100,
	"Extra Light": 200,
	"Light": 300,
	"Medium": 500,
	"Semibold": 600,
	"DemiBold": 600,
	"Semi Bold": 600,
	"Bold": 700,
	"Extrabold": 800,
	"Extra Bold": 800,
	"Black": 900
};


